import React, { useEffect, useState } from 'react';

import { Box, TextField } from '@mui/material';

import { RuleCondition } from '~/consts/agentHub';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => unknown;
  existingConditions: RuleCondition['value'];
}

function AgentHubCommissionsBundleTotalPriceInput({ setCreatedConditions, existingConditions }: Props) {
  const [value, setValue] = useState<number>((existingConditions?.[0]?.value as number) || 0);

  useEffect(() => {
    setCreatedConditions(
      {
        type: 'bundleTotalPrice',
        value: [{ label: 'Bundle total price', value }],
      },
      true,
    );
  }, [setCreatedConditions, value]);

  return (
    <Box>
      <TextField
        required
        name="Bundle total price"
        value={value}
        onChange={(e) => {
          setValue(parseInt(e.target.value, 10) || 0);
        }}
        InputProps={{ inputProps: { min: 0 }, sx: { borderRadius: 0.5 } }}
        label="Bundle total price"
        type="number"
        inputMode="decimal"
        fullWidth
      />
    </Box>
  );
}

export default AgentHubCommissionsBundleTotalPriceInput;
